<template>
    <div>
        <NavBar />

        <div class="container mx-auto">
            <header>
                <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <h1 class="text-3xl font-bold leading-tight text-gray-900">
                        Account
                    </h1>
                </div>
            </header>
        </div>

        <main class="container mx-auto">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="px-4 py-6 sm:px-0 border-2 border-dashed">
                    
                </div>
            </div>
        </main>
    </div>
    
</template>

<script>
import NavBar from "../components/NavBar";

export default {
    name: "My Profile",
    components: {
        NavBar,
    }
}
</script>